import { render, staticRenderFns } from "./PdfsPurchasesBP.vue?vue&type=template&id=4210e790&scoped=true"
import script from "./PdfsPurchasesBP.vue?vue&type=script&lang=js"
export * from "./PdfsPurchasesBP.vue?vue&type=script&lang=js"
import style0 from "./PdfsPurchasesBP.vue?vue&type=style&index=0&id=4210e790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4210e790",
  null
  
)

export default component.exports